import { render } from "./orgCourseAnalyseCreate.vue?vue&type=template&id=12317762&scoped=true"
import script from "./orgCourseAnalyseCreate.vue?vue&type=script&lang=js"
export * from "./orgCourseAnalyseCreate.vue?vue&type=script&lang=js"

import "./orgCourseAnalyseCreate.vue?vue&type=style&index=0&id=12317762&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12317762"]])

export default __exports__